import { Pecten, Sizes } from '@sede-enterprise/shell-ds-react-framework';
import { MobileNavContainer } from 'components/NavBar/NavBarMobile/NavBarMobile.styles';
import { UserProfileButton } from 'components/NavBar/UserProfileButton';
import { ReactNode, useCallback, useEffect, useState } from 'react';

export const NavBarMobile = ({ children }: { children: ReactNode }) => {
  const [lastScrollY, setLastScrollY] = useState(0);

  const navBar = document.getElementById('mobile-nav');
  const mobileHeader = document.getElementById('mobile-date-header');

  const handleNavbarPositionAnimation = useCallback(() => {
    if (window.scrollY === 0) {
      // scrolled to the top
      if (navBar) {
        navBar.style.position = 'relative';
        navBar.style.top = '0';
        navBar.style.transform = 'translateY(0)';
        navBar.style.visibility = 'visible';
      }
      if (mobileHeader) {
        mobileHeader.style.top = '0';
        mobileHeader.style.boxShadow = 'none';
      }
    } else if (window.scrollY > lastScrollY) {
      // scrolling down
      if (navBar && window.scrollY >= 65) {
        navBar.style.transform = 'translateY(-100%)';
        navBar.style.visibility = 'hidden';
      }
      if (mobileHeader && window.scrollY >= 65) {
        mobileHeader.style.top = '0';
        mobileHeader.style.boxShadow =
          '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.1)';
      }
    } else {
      // scrolling up
      if (navBar) {
        navBar.style.position = 'sticky';
        navBar.style.top = '0';
        navBar.style.transform = 'translateY(0)';
        navBar.style.visibility = 'visible';
      }
      if (mobileHeader && navBar) {
        mobileHeader.style.top = `${navBar.offsetHeight}px`;
      }
    }

    setLastScrollY(window.scrollY);
  }, [lastScrollY, mobileHeader, navBar]);

  useEffect(() => {
    window.addEventListener('scroll', handleNavbarPositionAnimation);

    return () =>
      window.removeEventListener('scroll', handleNavbarPositionAnimation);
  }, [lastScrollY, handleNavbarPositionAnimation]);

  return (
    <MobileNavContainer id={'mobile-nav'}>
      <Pecten size={Sizes.Medium} />
      {children}
      <UserProfileButton />
    </MobileNavContainer>
  );
};
